/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Story_ClearInputs */

const vi_shop_group_story_clear = /** @type {(inputs: Shop_Group_Story_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bỏ chọn câu chuyện`)
};

/**

* @param {Shop_Group_Story_ClearInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_story_clear = /** @type {((inputs?: Shop_Group_Story_ClearInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Story_ClearInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_story_clear(inputs)
});